import { UPDATE_ONBOARDING_STEP, SET_STREAMS_READY } from './constants';

export const updateOnboardingStep = (step, isCompleted) => ({
  type: UPDATE_ONBOARDING_STEP,
  payload: { step, isCompleted },
});

export const setStreamsReady = isReady => ({
  type: SET_STREAMS_READY,
  payload: isReady,
});
